import { useTranslate } from "../locales/hooks";
import { SupportedLanguages } from "../locales/interfaces";
import { NavigationItem } from "../modules/sunday-top-nav/navigation-menu";

const useNavigationItems = (language: SupportedLanguages): NavigationItem[] => {
  const t = useTranslate();

  return [
    {
      label: t("techRadarNavItem__label"),
      path: `/techradar/${language.toLowerCase()}`,
      isExternal: true,
    },
    {
      label: t("storybookNavItem__label"),
      path: "/storybook",
      isExternal: true,
      isNewTab: true,
    },
    {
      label: t("downloadNavItem__label"),
      path: "/download",
    },
    {
      label: t("contactNavItem__label"),
      path: "/contact",
    },
    {
      label: t("myCvNavItem__label"),
      path: "/cv",
    },
  ];
};

export { useNavigationItems };